var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_1_a{fill:#2e9e9e;}.step_1_b{clip-path:url(#a);}.step_1_c{fill:#1b205a;opacity:0.45;}.step_1_d{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_1_a",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(156 1347)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156 -1347)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_1_a",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(156 1347)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "step_1_b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_1_c",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(121 1379)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198 1401.925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "step_1_d",
    d: "M186.607,152.684h-1.761v-40.49a5.287,5.287,0,0,0-5.282-5.282H116.188a5.287,5.287,0,0,0-5.282,5.282v40.49h-1.761a3.525,3.525,0,0,0-3.521,3.521v7.042a3.525,3.525,0,0,0,3.521,3.521h72.177a8.813,8.813,0,0,0,8.8-8.8V156.2a3.522,3.522,0,0,0-3.519-3.52Zm-72.177-40.49a1.763,1.763,0,0,1,1.761-1.761h63.376a1.762,1.762,0,0,1,1.761,1.761v40.49H154.921a1.761,1.761,0,0,0-1.761,1.761,1.651,1.651,0,0,0,.064.316,2.629,2.629,0,0,0-.063.564v.88H142.6v-.88a2.591,2.591,0,0,0-.064-.564,1.656,1.656,0,0,0,.064-.317,1.76,1.76,0,0,0-1.761-1.761H114.431Zm72.177,45.772a5.287,5.287,0,0,1-5.282,5.282H109.148v-7.042h29.927v.879a2.644,2.644,0,0,0,2.641,2.641h12.323a2.644,2.644,0,0,0,2.641-2.641v-.88h29.927Z",
    transform: "translate(-105.625 -106.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "step_1_d",
    d: "M276.729,264.416v-3.067a11.909,11.909,0,0,0-11.9-11.9,1.763,1.763,0,0,0-1.208.48l-6.262,5.9-6.262-5.9a1.76,1.76,0,0,0-1.208-.48,11.909,11.909,0,0,0-11.9,11.9v3.067a2.644,2.644,0,0,0,2.641,2.641h33.447a2.644,2.644,0,0,0,2.641-2.641Zm-3.521-.88H241.521v-2.187a8.388,8.388,0,0,1,7.7-8.35l6.328,5.967a2.641,2.641,0,0,0,3.623,0L265.5,253a8.388,8.388,0,0,1,7.7,8.35Z",
    transform: "translate(-215.112 -224.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "step_1_d",
    d: "M307.892,165.235a8.8,8.8,0,1,0-8.8-8.8A8.813,8.813,0,0,0,307.892,165.235Zm0-14.083a5.282,5.282,0,1,1-5.282,5.282A5.287,5.287,0,0,1,307.892,151.151Z",
    transform: "translate(-265.64 -140.59)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step_1.dada25189eda1c1e76e1b34bfb15f861.svg";
export { ForwardRef as ReactComponent };